module.exports = __webpack_public_path__ + "AKL.c57b7e04.png";